import keys from "lodash/keys";
export var stripFilterPrefix = function (filters) {
    return keys(filters).reduce(function (stripedFilters, filterKey) {
        stripedFilters[filterKey.replace(/wsc_\d+/, "")] = filters[filterKey];
        return stripedFilters;
    }, {});
};
